"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var mobx_react_1 = require("mobx-react");

var ca_ui_toolkit_1 = require("ca-ui-toolkit");

var StringResources_1 = __importDefault(require("../../nls/StringResources"));

require("./conditionalColorComponent.scss");

var ConditionalColorPanelComponents_1 = __importDefault(require("../conditionalColorPanelComponents/ConditionalColorPanelComponents"));

var SummaryFillColorComponent_1 = __importDefault(require("../summaryFillColor/SummaryFillColorComponent"));

var ConditionalColorComponent =
/** @class */
function (_super) {
  __extends(ConditionalColorComponent, _super);

  function ConditionalColorComponent() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ConditionalColorComponent.prototype.render = function () {
    if (this.props.uiContext.isKpiVis()) {
      return this._getConditionalColorPanelForKPI();
    }

    var _a = this.props,
        uiContext = _a.uiContext,
        conditionalFormatsModel = _a.conditionalFormatsModel;
    var hasMeasures = this._getMstForUIPanels().getMeasures().length > 0;
    return react_1.default.createElement(ca_ui_toolkit_1.FlexLayout, {
      className: 'vis-color-properties',
      direction: 'column'
    }, react_1.default.createElement(SummaryFillColorComponent_1.default, {
      uiContext: uiContext,
      conditionalFormatsModel: conditionalFormatsModel
    }), react_1.default.createElement(ca_ui_toolkit_1.VSpacer, {
      size: 3
    }), hasMeasures && react_1.default.createElement(ca_ui_toolkit_1.Separator, {
      hMargin: 0,
      className: 'vis-cf-summary-conditional-separator',
      orientation: 'horizontal'
    }), hasMeasures && react_1.default.createElement(ca_ui_toolkit_1.FlexItem, null, this._getMeasureCondFormatLinks()));
  };

  ConditionalColorComponent.prototype._getConditionalColorPanelForKPI = function () {
    var uiContext = this.props.uiContext;
    var cfState = uiContext.getConditionalFormattingState();
    var cfAPI = cfState.getConditionalFormattingApi();
    var measures = cfAPI.getConditionalFormatMeasures();

    var mstForUIPanels = this._getMstForUIPanels();

    mstForUIPanels.setMeasureDataItem(measures[0]);
    return react_1.default.createElement(ConditionalColorPanelComponents_1.default, {
      uiContext: uiContext,
      mstForUIPanels: mstForUIPanels
    });
  };

  ConditionalColorComponent.prototype._handleOnClick = function (measureDataItem) {
    var uiContext = this.props.uiContext;
    uiContext.displayChildPanelForMeasure(measureDataItem);
  };

  ConditionalColorComponent.prototype._getMeasureCondFormatLinks = function () {
    var _this = this;

    var result = [];

    var measures = this._getMstForUIPanels().getMeasures();

    if (measures.length) {
      result = [react_1.default.createElement(ca_ui_toolkit_1.VSpacer, {
        size: 1,
        key: 'vspacer-before-conditional-color'
      }), react_1.default.createElement(ca_ui_toolkit_1.Label, {
        className: 'vis-conditional-color',
        label: StringResources_1.default.get('conditionalColor'),
        key: 'conditionalColor'
      }), react_1.default.createElement(ca_ui_toolkit_1.VSpacer, {
        size: 2,
        key: 'vspacer-after-conditional-color'
      }), react_1.default.createElement(ca_ui_toolkit_1.LabelSection, {
        className: 'vis-cf-availableData',
        label: StringResources_1.default.get('conditionalFormatttingAvailableData'),
        rtl: false,
        key: 'availableData'
      }), react_1.default.createElement(ca_ui_toolkit_1.VSpacer, {
        size: 1,
        key: 'vspacer-available-data'
      })];
      result.push.apply(result, measures.map(function (measure, index) {
        return react_1.default.createElement(ca_ui_toolkit_1.LinkSection, {
          className: 'vis-cf-measureIndividualCondFormatLink',
          "data-id": measure.getDataItemId(),
          label: measure.getLabel(),
          rtl: false,
          disabled: false,
          onClick: _this._handleOnClick.bind(_this, measure),
          key: index
        });
      }));
    }

    return result;
  };

  ConditionalColorComponent.prototype._getMstForUIPanels = function () {
    var uiContext = this.props.uiContext;
    var cfState = uiContext.getConditionalFormattingState();
    return cfState.getMstForUIPanels();
  };

  return ConditionalColorComponent;
}(react_1.Component);

exports.default = mobx_react_1.observer(ConditionalColorComponent);
